/**
 * Core publishes `slug` as the journal's panel base, https://dashboard.<domain>/<abbr> (rows written before the
 * move still read https://<abbr>.<domain>). The journal's Laravel API lives at https://api.<domain>/<abbr>.
 */
export const journalApiBase = (slug?: string | null): string | null => {
  if (!slug) {
    return null;
  }

  try {
    const url = new URL(slug);

    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return null;
    }

    const labels = url.hostname.split(".");
    const segment = url.pathname.split("/").filter(Boolean)[0];
    const parent = labels.slice(1).join(".");
    const abbreviation = labels[0] === "dashboard" && segment ? segment : labels[0];

    return `${url.protocol}//api.${parent}/${abbreviation}`;
  } catch {
    return null;
  }
};
